import { string, number, shape, arrayOf } from 'prop-types';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

const languageRegionCodes = Object.values(LanguageRegionCode);

/**
 * @deprecated use import { Trail } from 'type/Trails/Trail'
 */
export default shape({
  ID: number,
  activities: arrayOf(string),
  area_id: number,
  area_name: string,
  area_name_de: string,
  area_name_en: string,
  area_name_es: string,
  area_name_fr: string,
  ...Object.assign({}, ...languageRegionCodes.map(languageRegionCode => ({ [`area_name_${languageRegionCode}`]: string }))),
  area_slug: string,
  avg_rating: number,
  city_id: number,
  city_name: string,
  country_id: number,
  country_name: string,
  description: string,
  description_de: string,
  description_en: string,
  description_es: string,
  description_fr: string,
  ...Object.assign({}, ...languageRegionCodes.map(languageRegionCode => ({ [`description_${languageRegionCode}`]: string }))),
  difficulty_rating: string,
  duration_minutes: number,
  elevation_gain: number,
  features: arrayOf(string),
  length: number,
  name: string,
  name_de: string,
  name_en: string,
  name_es: string,
  name_fr: string,
  ...Object.assign({}, ...languageRegionCodes.map(languageRegionCode => ({ [`name_${languageRegionCode}`]: string }))),
  num_photos: number,
  num_reviews: number,
  objectID: string,
  overview: string,
  park_slug: string,
  popularity: number,
  profile_photo_url: string,
  route_type: string,
  slug: string,
  state_id: number,
  state_name: string,
  trail_id: number,
  type: string,
  units: string,
  verified_map_id: number,
  visitor_usage: string,
  _geoloc: shape({ lat: number, lng: number })
});
